import React, { useEffect, useState } from 'react';
import { FaCheck, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi';
import { useConfiguration } from 'src/hooks/Configuration';
import { useModal } from 'src/hooks/Modal';
import Input from '../components/Forms/Input';
import MaskedInput from '../components/Forms/MaskedInput';

import SelectSimple from '../components/Forms/SelectSimple';
import { useLanguage } from "../hooks/Language"

import api from '../services/api';
import CheckboxInput from './DashboardPages/core/components/Forms/CheckboxInput';
import { countries } from './LeadForm/FormContainer/countries';
import states from './SignUp/FormContainer/states';
import { validaCPF } from 'src/utils/validate';

interface IProps {
    changeCountry: Function;
    countryISO: string;
    checkUserValue?: Function;
    cart?: Record<string, any>[];
    key?: string;
    keyName?: string;
}

export const checkDocumentNumber = async (document_number,pais) => {

    if(pais === 'BR'){
       const validDoc = validaCPF(document_number);
       if(!validDoc){
return 'not-valid'
       }
    }


    const valid = await api.get('check-user-document_number', { params: { document_number: document_number } });

    return valid?.data?.valid || 'no';

}


const DefaultSignUpFormV4: React.FC<IProps> = ({ key = 'product', keyName = 'product', checkUserValue = (value) => { }, changeCountry, cart }) => {
    const { configuration } = useConfiguration();
    const [countryISO, setCountryISO] = useState('BR')
    const [checkUser, setCheckUser] = useState('')
    const [currentDocumentNumber, setCurrentDocumentNumber] = useState('');
    const { translate } = useLanguage();
    const [product, setProduct] = useState<Record<string, any>>({});
    const [position, setPosition] = useState('');
    const [stateValue, setStateValue] = useState('');
    const [category, setCategory] = useState('');
    const [otherCompany, setOtherCompany] = useState('');
    const { addModal } = useModal();
    const allowedPositions = product?.allowed_categories?.length > 0 ?

        product?.allowed_categories?.reduce((prev, item) => {

            const split = item?.split('>');

            prev.push({ label: split?.[0]?.trim(), value: split?.[0]?.trim() })

            return prev;

        }, [])


        : [];

    const allowedCategories = product?.allowed_categories?.length > 0 ?

        product?.allowed_categories?.reduce((prev, item) => {

            const split = item?.split('>');

            if (split?.[1] && split?.[1]?.trim()) {

                prev.push({ label: split?.[1]?.trim(), value: split?.[1]?.trim() })
            }



            return prev;

        }, [])


        : [];


    useEffect(() => {
        setCheckUser('');
        checkUserValue('');
    }, [keyName])
    const verifyAssociate = async (doc, product) => {



        try {

            const validate = await api.get(`/verify-association-api/${product?.hash_link?.toString()}/${product?.project_id}/${doc}`);

            if (validate.status === 200) {
                return true;
            }
            else {
                return false;
            }


        }
        catch (err) {

            addModal({ theme: 'whiteModalMini', title: '', content: <> <p style={{ color: '#333', padding: '10px', fontSize: '14px', textAlign: 'center', width: '100%' }}>{err?.response?.data?.message || err?.response?.data?.error || 'Produto exclusivo para associados'} </p></> })
            return false;
        }



    }


    return <>
        <SelectSimple index={1} mandatory={true} setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={translate('Pais')} />


        {countryISO === 'BR' ? <MaskedInput
            mask="999.999.999-99"
            name="document_number"
            setCallback={(value) => setCurrentDocumentNumber(value)}
            placeholder={translate('CPF')}
        /> : <Input setCallback={(value) => setCurrentDocumentNumber(value)} name="document_number"
            placeholder={translate('Nº do documento')} />}

        {!checkUser ? <button type='button' style={{ margin: '5px auto' }} onClick={async () => {


            const product = cart?.[0];

            if (product?.allowed_only === 'Sim') {
                const checkAssociation = await verifyAssociate(currentDocumentNumber, product);
                if (!checkAssociation) {
                    return;
                }
                else {
                    const check = await checkDocumentNumber(currentDocumentNumber, countryISO);

                    if(check === 'not-valid'){
                        addModal({title: '', content:<p style={{fontSize: '14px', color: '#333'}}>Insira um CPF Válido</p>, theme: 'whiteModalMini'});
                        return;
                    }

                    setCheckUser(check);
                    checkUserValue(check);
                }
            }
            else {

                const check = await checkDocumentNumber(currentDocumentNumber, countryISO);

                       if(check === 'not-valid'){
                        addModal({title: '', content:<p style={{fontSize: '14px', color: '#333'}}>Insira um CPF Válido</p>, theme: 'whiteModalMini'});
                        return;
                    }


                setCheckUser(check);
                checkUserValue(check);

            }



        }} className='greenButton2 buttonColored'>Validar</button> : <></>}
        {checkUser === 'no' ? <>

            <Input name="name" placeholder="Nome completo" />
            <Input name="email" placeholder="E-mail" />
   {countryISO === 'BR' ? <MaskedInput
                mask="(99) 999999999"
                name="phone"
                placeholder="Telefone com DDD"
            /> : <Input name="phone" placeholder={translate('Telefone com DDD')} />}
            <SelectSimple index={1} setCallback={(value) => setPosition(value)}
                options={configuration?.exclusive ? [{ value: configuration?.exclusive, label: translate(configuration?.exclusive) },] :
                    allowedPositions?.length > 0 ? allowedPositions : [
                        { value: 'Médico', label: translate('Médico') },
                        { value: 'Estudante', label: translate('Estudante') },
                        { value: 'Profissional da área da saúde', label: translate('Profissional da área da saúde') },

                        { value: 'Outro', label: translate('Outra') },
                    ]}
                name="position"

                label="Profissão"
            />
            {position === 'Médico' && <>
                <Input
                    name="crm"
                    placeholder="CRM"
                />

                <SelectSimple index={2}
                    options={states}
                    name="cpf_familiar"

                    label={translate('Estado do CRM')}
                />

                <SelectSimple index={3}
                    options={allowedCategories?.length > 0 ? allowedCategories : [


                        { value: 'Acupuntura', label: translate('Acupuntura') },
                        { value: 'Alergia e imunologia', label: translate('Alergia e imunologia') },
                        { value: 'Anestesiologia', label: translate('Anestesiologia') },
                        { value: 'Angiologia', label: translate('Angiologia') },
                        { value: 'Cardiologia', label: translate('Cardiologia') },
                        { value: 'Cirurgia cardiovascular', label: translate('Cirurgia cardiovascular') },
                        { value: 'Cirurgia da mão', label: translate('Cirurgia da mão') },
                        { value: 'Cirurgia de cabeça e pescoço', label: translate('Cirurgia de cabeça e pescoço') },
                        { value: 'Cirurgia do aparelho digestivo', label: translate('Cirurgia do aparelho digestivo') },
                        { value: 'Cirurgia geral', label: translate('Cirurgia geral') },
                        { value: 'Cirurgia oncológica', label: translate('Cirurgia oncológica') },
                        { value: 'Cirurgia pediátrica', label: translate('Cirurgia pediátrica') },
                        { value: 'Cirurgia plástica', label: translate('Cirurgia plástica') },
                        { value: 'Cirurgia torácica', label: translate('Cirurgia torácica') },
                        { value: 'Cirurgia vascular', label: translate('Cirurgia vascular') },
                        { value: 'Clínica médica', label: translate('Clínica médica') },
                        { value: 'Coloproctologia', label: translate('Coloproctologia') },
                        { value: 'Dermatologia', label: translate('Dermatologia') },
                        { value: 'Endocrinologia e metabologia', label: translate('Endocrinologia e metabologia') },
                        { value: 'Endoscopia', label: translate('Endoscopia') },
                        { value: 'Gastroenterologia', label: translate('Gastroenterologia') },
                        { value: 'Genética médica', label: translate('Genética médica') },
                        { value: 'Geriatria', label: translate('Geriatria') },
                        { value: 'Ginecologia e obstetrícia', label: translate('Ginecologia e obstetrícia') },
                        { value: 'Hematologia e hemoterapia', label: translate('Hematologia e hemoterapia') },
                        { value: 'Homeopatia', label: translate('Homeopatia') },
                        { value: 'Infectologia', label: translate('Infectologia') },
                        { value: 'Mastologia', label: translate('Mastologia') },
                        { value: 'Medicina de emergência', label: translate('Medicina de emergência') },
                        { value: 'Medicina de família e comunidade', label: translate('Medicina de família e comunidade') },
                        { value: 'Medicina do trabalho', label: translate('Medicina do trabalho') },
                        { value: 'Medicina de tráfego', label: translate('Medicina de tráfego') },
                        { value: 'Medicina esportiva', label: translate('Medicina esportiva') },
                        { value: 'Medicina física e reabilitação', label: translate('Medicina física e reabilitação') },
                        { value: 'Medicina intensiva', label: translate('Medicina intensiva') },
                        { value: 'Medicina legal e perícia médica', label: translate('Medicina legal e perícia médica') },
                        { value: 'Medicina nuclear', label: translate('Medicina nuclear') },
                        { value: 'Medicina preventiva e social', label: translate('Medicina preventiva e social') },
                        { value: 'Nefrologia', label: translate('Nefrologia') },
                        { value: 'Neurocirurgia', label: translate('Neurocirurgia') },
                        { value: 'Neurologia', label: translate('Neurologia') },
                        { value: 'Nutrologia', label: translate('Nutrologia') },
                        { value: 'Oftalmologia', label: translate('Oftalmologia') },
                        { value: 'Oncologia clínica', label: translate('Oncologia clínica') },
                        { value: 'Ortopedia e traumatologia', label: translate('Ortopedia e traumatologia') },
                        { value: 'Otorrinolaringologia', label: translate('Otorrinolaringologia') },
                        { value: 'Patologia', label: translate('Patologia') },
                        { value: 'Patologia clínica/medicina laboratorial', label: translate('Patologia clínica/medicina laboratorial') },
                        { value: 'Pediatria', label: translate('Pediatria') },
                        { value: 'Pneumologia', label: translate('Pneumologia') },
                        { value: 'Psiquiatria', label: translate('Psiquiatria') },
                        { value: 'Radiologia e diagnóstico por imagem', label: translate('Radiologia e diagnóstico por imagem') },
                        { value: 'Radioterapia', label: translate('Radioterapia') },
                        { value: 'Reumatologia', label: translate('Reumatologia') },
                        { value: 'Urologia', label: translate('Urologia') },
                        { value: 'Outra', label: translate('Outra') },

                    ]}
                    name="category_id"

                    label={translate("Especialidade")}
                /> </>}

            {position === 'Profissional da área da saúde' ? <SelectSimple index={4}
                options={allowedCategories?.length > 0 ? allowedCategories : [
                    { value: "Enfermagem", label: translate("Enfermagem") },
                    { value: "Fonoaudiologia", label: translate("Fonoaudiologia") },
                    { value: "Psicologia", label: translate("Psicologia") },
                    { value: "Fisioterapia", label: translate("Fisioterapia") },
                    { value: "Farmácia", label: translate("Farmácia") },
                    { value: "Nutrição", label: "Nutrição" },
                    { value: "Terapia Ocupacional", label: translate("Terapia Ocupacional") },
                    { value: 'Outra', label: translate('Outra') },

                ]}
                name="category_id"

                label={translate("Área")}
                setCallback={(value) => { setCategory(value) }}
            /> : <></>}

            {category === 'Farmácia' ? <>

                <Input
                    name="crm"
                    placeholder="CRF"
                />

                <SelectSimple index={5}
                    options={states}
                    name="cpf_familiar"

                    label={translate('Estado do CRF')}
                />

            </> : <></>}
            {category === 'Fisioterapia' ? <>

                <Input
                    name="crm"
                    placeholder="CREFITO"
                />

                <SelectSimple index={6}
                    options={states}
                    name="cpf_familiar"

                    label={translate('Estado do CREFITO')}
                />

            </> : <></>}

            {category === 'Nutrição' ? <>

                <Input
                    name="crm"
                    placeholder="CRN"
                />

                <SelectSimple index={7}
                    options={states}
                    name="cpf_familiar"

                    label={translate('Estado do CRN')}
                />

            </> : <></>}

            {category === 'Enfermagem' ? <>

                <Input
                    name="crm"
                    placeholder="CRE"
                />

                <SelectSimple index={8}
                    options={states}
                    name="cpf_familiar"

                    label={translate('Estado do CRE')}
                />

            </> : <></>}


            {category === 'Fisioterapia' ? <>

                <Input
                    name="crm"
                    placeholder="CRF"
                />

                <SelectSimple index={9}
                    options={states}
                    name="cpf_familiar"

                    label={translate('Estado do CRF')}
                />

            </> : <></>}

            {category === 'Fonoaudiologia' ? <>

                <Input
                    name="crm"
                    placeholder="CRF"
                />

                <SelectSimple index={10}
                    options={states}
                    name="cpf_familiar"

                    label={translate('Estado do CRF')}
                />

            </> : <></>}

            {position === 'Estudante' ?
                <SelectSimple index={11}
                    name="category_id"

                    label={translate("Área")}
                    options={allowedCategories?.length > 0 ? allowedCategories : [
                        { value: "Administração", label: translate("Administração") },
                        { value: "Agronomia", label: translate("Agronomia") },
                        { value: "Arquitetura e Urbanismo", label: translate("Arquitetura e Urbanismo") },
                        { value: "Arquivologia", label: translate("Arquivologia") },
                        { value: "Artes Visuais", label: translate("Artes Visuais") },
                        { value: "Biblioteconomia", label: translate("Biblioteconomia") },
                        { value: "Biologia", label: translate("Biologia") },
                        { value: "Biomedicina", label: translate("Biomedicina") },
                        { value: "Biotecnologia", label: translate("Biotecnologia") },
                        { value: "Ciência da Computação", label: translate("Ciência da Computação") },
                        { value: "Ciências Sociais", label: translate("Ciências Sociais") },
                        { value: "Comunicação Social", label: translate("Comunicação Social") },
                        { value: "Contabilidade", label: translate("Contabilidade") },
                        { value: "Dança", label: translate("Dança") },
                        { value: "Design", label: translate("Design") },
                        { value: "Direito", label: translate("Direito") },
                        { value: "Economia", label: translate("Economia") },
                        { value: "Educação Física", label: translate("Educação Física") },
                        { value: "Enfermagem", label: translate("Enfermagem") },
                        { value: "Engenharia Ambiental", label: translate("Engenharia Ambiental") },
                        { value: "Engenharia Civil", label: translate("Engenharia Civil") },
                        { value: "Engenharia Elétrica", label: translate("Engenharia Elétrica") },
                        { value: "Engenharia Física", label: translate("Engenharia Física") },
                        { value: "Engenharia Hídrica", label: translate("Engenharia Hídrica") },
                        { value: "Engenharia Mecânica", label: translate("Engenharia Mecânica") },
                        { value: "Engenharia Metalúrgica", label: translate("Engenharia Metalúrgica") },
                        { value: "Engenharia Química", label: translate("Engenharia Química") },
                        { value: "Engenharia de Alimentos", label: translate("Engenharia de Alimentos") },
                        { value: "Engenharia de Computação", label: translate("Engenharia de Computação") },
                        { value: "Engenharia de Controle e Automação", label: translate("Engenharia de Controle e Automação") },
                        { value: "Engenharia de Energia", label: translate("Engenharia de Energia") },
                        { value: "Engenharia de Materiais", label: translate("Engenharia de Materiais") },
                        { value: "Engenharia de Minas", label: translate("Engenharia de Minas") },
                        { value: "Engenharia de Produção", label: translate("Engenharia de Produção") },
                        { value: "Estatística", label: translate("Estatística") },
                        { value: "Farmácia", label: translate("Farmácia") },
                        { value: "Filosofia", label: translate("Filosofia") },
                        { value: "Fisioterapia", label: translate("Fisioterapia") },
                        { value: "Fonoaudiologia", label: translate("Fonoaudiologia") },
                        { value: "Física", label: translate("Física") },
                        { value: "Geografia", label: translate("Geografia") },
                        { value: "Geologia", label: translate("Geologia") },
                        { value: "História", label: translate("História") },
                        { value: "História da Arte", label: translate("História da Arte") },
                        { value: "Letras", label: translate("Letras") },
                        { value: "Matemática", label: translate("Matemática") },
                        { value: "Medicina", label: translate("Medicina") },
                        { value: "Veterinária", label: translate("Veterinária") },
                        { value: "Museologia", label: translate("Museologia") },
                        { value: "Música", label: translate("Música") },
                        { value: "Nutrição", label: translate("Nutrição") },
                        { value: "Odontologia", label: translate("Odontologia") },
                        { value: "Pedagogia", label: translate("Pedagogia") },
                        { value: "Políticas Públicas", label: translate("Políticas Públicas") },
                        { value: "Psicologia", label: translate("Psicologia") },
                        { value: "Química", label: translate("Química") },
                        { value: "Relações Internacionais", label: translate("Relações Internacionais") },
                        { value: "Saúde Coletiva", label: translate("Saúde Coletiva") },
                        { value: "Serviço Social", label: translate("Serviço Social") },
                        { value: "Teatro", label: translate("Teatro") },
                        { value: "Zootecnia", label: translate("Zootecnia") },
                        { value: 'Outra', label: translate('Outra') },
                    ]} />


                : <></>}

            { /* (position === 'Estudante' || position === 'Profissional da área da saúde' || position === 'Outro? Qual?') &&
              <Input
                name="especialidade"
                placeholder="Especifique"
              />
              */  }


            <SelectSimple index={12} setCallback={(value) => setOtherCompany(value)}
                options={[
                    { value: 'Dasa', label: 'Dasa' },
                    { value: 'Outro? Qual?', label: translate('Outra?') },
                ]}
                name="company"

                label={translate("Organização")}
            />

            {otherCompany === 'Outro? Qual?' &&

                <Input
                    name="extra_4"
                    placeholder={translate("Informe o nome da organização")}
                />
            }


             


            {countryISO !== 'BR' ?

                <SelectSimple index={14} options={[
                    { value: 'passport', label: translate('Passaporte') },
                    { value: 'other', label: translate('Documento local') },
                ]} name="document_type" label={translate('Tipo de documento pessoal')}
                />



                : <></>}



            <MaskedInput
                mask="99/99/9999"
                name="extra_1"
                placeholder={translate("Data de nascimento (DD/MM/AAAA)")}
            />


            <Input
                icon={FiLock}
                name="password"
                type="password"
                placeholder={translate('Cadastre sua senha de acesso')}
            />



            {countryISO === 'BR' ? <SelectSimple index={15} setCallback={(value) => {
                setStateValue(value);
            }} options={states} name="state" label={translate("Estado")} /> :

                <Input name="state" placeholder={translate('Província / Região da Fundação')} />}

  <Input
                    name="city"
                    placeholder="Cidade"
                />

         

            <SelectSimple index={16}

                options={[
                    { label: translate('Visitação Médica'), value: 'Visitação Médica' },
                    { label: translate('NAM - Núcleo de Assessoria Médica'), value: 'NAM - Núcleo de Assessoria Médica' },
                    { label: translate('WhatsApp'), value: 'WhatsApp' },
                    { label: translate('Indicação'), value: 'Indicação' },
                    { label: translate('Instagram'), value: 'Instagram' },
                    { label: translate('Facebook'), value: 'Facebook' },
                    { label: translate('Linkedin'), value: 'Linkedin' },
                    { label: translate('E-mail marketing'), value: 'E-mail marketing' },
                    { label: translate('SMS'), value: 'SMS' },
                    { label: translate('Workplace'), value: 'Workplace' },
                    { label: translate('Google'), value: 'Google' },
                    { label: translate('Outros'), value: 'Outros' },





                ]}
                name="know_about"

                label={window?.location?.pathname?.indexOf('/biblioteca') >= 0 ? translate("Como ficou sabendo do evento/conteúdo científico?") : translate("Como ficou sabendo do evento?")}
            />



            <SelectSimple index={17}

                options={[
                    { label: translate('Sim'), value: 'Sim' },
                    { label: translate('Não'), value: 'Não' },


                ]}
                name="extra_5"

                label={window?.location?.pathname?.indexOf('/biblioteca') >= 0 ? translate("Gostaria de receber futuras comunicações sobre eventos/novos conteúdos publicados?") : translate("Gostaria de receber futuras comunicações sobre eventos?")}
            />

            <CheckboxInput
                style={{ display: 'flex' }}
                name="term"
                unique={true}
                preText={(
                    <>
                        {' '}
                        Estou ciente de que estou fornecendo à DASA EDUCA, parceiros e patrocinadores meus contatos gerais, os quais são dados pessoais protegidos pela Lei Geral de Proteção de Dados brasileira, para gestão de relacionamento e marketing da empresa, conforme Política de Privacidade disponível neste site.
                        {' '}

                    </>
                )}
                options={[
                    {
                        id: `Sim, eu autorizo o compartilhamento dos meus dados`,
                        label: translate('Sim, eu autorizo o compartilhamento dos meus dados'),
                        value: `Sim, eu autorizo o compartilhamento dos meus dados`,
                    },
                    {
                        id: `Não autorizo o compartilhamento dos meus dados`,
                        label: translate('Não autorizo o compartilhamento dos meus dados'),
                        value: `Não autorizo o compartilhamento dos meus dados`,
                    },
                ]}
            />
        </> : <></>
        }




        {checkUser === 'yes' ? <div className='row'><FaCheck style={{ color: 'green', fontSize: '18px' }} /> <p>Usuário identificado</p></div> : <></>}


    </>
}

export default DefaultSignUpFormV4;